import { Response } from '@angular/http';
import { Injectable } from '@angular/core';

// Rxjs
import { _throw } from 'rxjs/observable/throw';
import { Observable } from 'rxjs/Observable';

// Services
import { HttpService } from './http.service';

// Base URL
import { BASE_URL } from './api';

@Injectable()
export class NotificationService {

  // Base URL
  private PATH: string = BASE_URL + 'notification/';

  // Constructor
  constructor(private http: HttpService) { }

  // Get User Notifications
  public getUserNotification(): Observable<Response> {
    return this.http.get(this.PATH + 'notification/user-notifications');
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/notification.service.ts